import { useDispatch, useSelector } from "react-redux";

import { ToastList } from "@similarweb/ui-components";

import { hideToast } from "app/actions/toast_actions";

const ToastContainer = () => {
    const dispatch = useDispatch();
    const toasts = useSelector((state) => state.ui.toasts);

    const handleHideToast = (toast) => dispatch(hideToast(toast));

    return (
        <ToastList
            toasts={toasts}
            onHideToast={handleHideToast}
        />
    );
};

export default ToastContainer;
